// FILE: projectIdentity.ts
// Purpose: Shared project colour choices and deterministic identity presentation.

import { nameToHue } from "~/lib/nameColor";

export const PROJECT_COLOR_PALETTE = [
  { label: "Rojo", value: "#d64545" },
  { label: "Naranja", value: "#d97706" },
  { label: "Ámbar", value: "#b7791f" },
  { label: "Lima", value: "#65a30d" },
  { label: "Verde", value: "#2f855a" },
  { label: "Teal", value: "#0f766e" },
  { label: "Cian", value: "#0e7490" },
  { label: "Azul", value: "#2563eb" },
  { label: "Índigo", value: "#4f46e5" },
  { label: "Violeta", value: "#7c3aed" },
  { label: "Fucsia", value: "#c026d3" },
  { label: "Rosa", value: "#db2777" },
] as const;

export function isValidProjectColor(value: string): boolean {
  return /^#[0-9a-f]{6}$/.test(value);
}

export function normalizeProjectColorInput(raw: string): string | null {
  const value = raw.trim().toLowerCase();
  const normalized = value.startsWith("#") ? value : `#${value}`;
  return isValidProjectColor(normalized) ? normalized : null;
}

export function resolveProjectColor(project: {
  readonly name: string;
  readonly color?: string | null;
}): string {
  if (project.color !== null && project.color !== undefined) {
    const normalized = normalizeProjectColorInput(project.color);
    if (normalized !== null) return normalized;
  }
  return `hsl(${nameToHue(project.name)} 55% 45%)`;
}
